import { atom } from 'jotai';

export const showActivityWizardAtom = atom<boolean>(false);
